import { useState } from "react";
import constate from "constate";

const [AlertListProvider, useAlertList] = constate(() => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sort, setSort] = useState("refreshed_at|desc");
  const [filter, setFilter] = useState(null);
  const [count, setCount] = useState(null);

  // RC page (Q1): status filter as two independent Toggle pills, mirroring
  // useListingList's Consignment/In Stock pattern, instead of the legacy
  // dropdown. `alert.status` is a single boolean field on the backend, so the
  // two pills behave like a radio — turning one on turns the other off, and
  // turning the active one off again clears the filter back to "all".
  const [showActive, setShowActiveRaw] = useState(false);
  const [showInactive, setShowInactiveRaw] = useState(false);

  const setShowActive = (next) => {
    setShowActiveRaw(next);
    if (next) setShowInactiveRaw(false);
  };

  const setShowInactive = (next) => {
    setShowInactiveRaw(next);
    if (next) setShowActiveRaw(false);
  };

  const onSearchQueryChange = (query) => {
    setSearchQuery(query);
  };

  const listParams = {
    query: searchQuery,
    onResultsLoaded: (_, cnt) => setCount(cnt),
  };

  if (sort) {
    const sortArr = sort.split("|");
    listParams.sort = { field: sortArr[0], direction: sortArr[1] };
  }

  if (filter) {
    listParams.filters = filter;
  }

  if (showActive) {
    listParams.filters = { ...listParams.filters, status: 1 };
  } else if (showInactive) {
    listParams.filters = { ...listParams.filters, status: 0 };
  }

  return {
    onSearchQueryChange,
    sort,
    setSort,
    filter,
    setFilter,
    showActive,
    setShowActive,
    showInactive,
    setShowInactive,
    listParams,
    count,
  };
});

export { AlertListProvider, useAlertList };
